import { Controller } from "stimulus";
import moment from 'moment';
import {House, Room, RoomType, enums} from "./model";
import { MinLosLevelColorDescription } from "./min_los_level_color_description_helper";

import("./component.scss")
const CSS_MATCHER_MINLOS_TABLE_ENTRY = 'table.tightTable tr'

export default class extends Controller {

    initialize() {
        super.initialize();
        this.TIME_FORMAT = 'YYYY-MM-DD';
        
        this.usermodifieddates = undefined 
        this.levels_selector = this.element.querySelector('#levels'); // Set a global reference here, for performance reasons.
        this.currentHouseID = this.element.getAttribute("house_id");
        this.apierrormsg = this.element.querySelector('#notice');
        this.currentlevel = this.levels_selector.selectedIndex
        
        this.confirmdialog = {
            open (options) {
                options = Object.assign({}, {
                    title: '',
                    message: '',
                    okText: 'OK',
                    cancelText: document.querySelector("#search_house_or_room > div:nth-child(10) > div").getAttribute('calendar_cancel'),
                    onok: function () {},
                    oncancel: function () {}
                }, options);
                
                const html = `
                    <div class="confirm">
                        <div class="confirm__window">
                            <div class="confirm__titlebar">
                                <span class="confirm__title">${options.title}</span>
                                <button class="confirm__close">&times;</button>
                            </div>
                            <div class="confirm__content">${options.message}</div>
                            <div class="confirm__buttons">
                                <button class="confirm__button confirm__button--ok confirm__button--fill">${options.okText}</button>
                                <button class="confirm__button confirm__button--cancel">${options.cancelText}</button>
                            </div>
                        </div>
                    </div>
                `;
    
                const template = document.createElement('template');
                template.innerHTML = html;
    
                // Elements
                const confirmEl = template.content.querySelector('.confirm');
                const btnClose = template.content.querySelector('.confirm__close');
                const btnOk = template.content.querySelector('.confirm__button--ok');
                const btnCancel = template.content.querySelector('.confirm__button--cancel');
    
                confirmEl.addEventListener('click', e => {
                    if (e.target === confirmEl) {
                        options.oncancel();
                        this._close(confirmEl);
                    }
                });
    
                btnOk.addEventListener('click', () => {
                    options.onok();
                    this._close(confirmEl);
                });
    
                [btnCancel, btnClose].forEach(el => {
                    el.addEventListener('click', () => {
                        options.oncancel();
                        this._close(confirmEl);
                    });
                });
    
                document.body.appendChild(template.content);
            },
    
            _close (confirmEl) {
                confirmEl.classList.add('confirm--close');
    
                confirmEl.addEventListener('animationend', () => {
                    document.body.removeChild(confirmEl);
                });
            }
        };


    }

    connect() {
        // get structure from API
        this.getDataFromAPI('/api/v1/houses/all').then( e => {
            // Populate room selector
            let houseMap = House.create_houses_map(e)
            this.houseMap = houseMap
            let currentSelectHouse = houseMap.get(this.currentHouseID)
            if(currentSelectHouse){
                this.populate_level_chooser (currentSelectHouse)
            } else {
                // TODO handle error case
            }
        })

        let from = this.from = this.get_default_date_from_attribute("default_from").startOf('day')
        let till = this.till = this.get_default_date_from_attribute("default_to").startOf('day')
        let self = this
        let cal_translation_daynames = JSON.parse(this.get_data_from_attribute("calendar_locale_daynames"))
        let cal_translation_monthnames = JSON.parse(this.get_data_from_attribute("calendar_locale_monthnames"))

        $('input[name="daterange"]').daterangepicker({
        
            locale: {
                format: this.get_data_from_attribute("calendar_date_format"),
                separator: " - ",
                applyLabel: this.get_data_from_attribute("calendar_apply"),
                cancelLabel: this.get_data_from_attribute("calendar_cancel"),
                fromLabel: "From",
                toLabel: "To",
                customRangeLabel: "Custom",
                weekLabel: "W",
                daysOfWeek: cal_translation_daynames,
                monthNames: cal_translation_monthnames,
                firstDay: 1
            },
            startDate: from,
            endDate: till
        }, function(start, end, label) {
            let from = start.startOf('day');
            let till = end.startOf('day');
            self.setDateRange(from, till);
            self.ShowDates(from, till);
        });

        // Code for collapsable bulk update view
        var coll = this.element.getElementsByClassName("collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
            coll[i].addEventListener("click", function() {
                var content = this.nextElementSibling;
                if (content.style.maxHeight){
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                }
            });
        }
        this.ShowDates(this.from, this.till)
    }

    populate_level_chooser(house){
        let self = this
        
        // fix house select option to this house
        // this.create_dom_element_option_at_selector(this.house_selector, house.get_id, house.get_name)

        // set levels - roomtype select options
        self.create_dom_element_option_at_selector(this.levels_selector, "", this.get_data_from_attribute("category_seperator"))

        house.get_roomtype_mapping.forEach((roomtype) =>
            self.create_dom_element_option_at_selector(this.levels_selector, roomtype.get_id, roomtype.get_name, enums.levelSelector.CATEGORY)
        )

        // set levels - rooms select options
        self.create_dom_element_option_at_selector(this.levels_selector, "", this.get_data_from_attribute("room_seperator"))
        house.get_rooms_mapping.forEach((room) =>
            self.create_dom_element_option_at_selector(this.levels_selector,room.get_id, room.get_name, enums.levelSelector.ROOM)
        )
    }

    // fill the data in the select for levels
    create_dom_element_option_at_selector(selector, id, text, value){
        let thisoption = document.createElement('option');
        if (id == ""){
            // this is a seperator
            thisoption.disabled = true;
            thisoption.value = ""
        } else {
            // this is a real option
            thisoption.setAttribute('id', id);
            let previous_option_value = selector.lastElementChild.value
            thisoption.setAttribute('value', parseInt(previous_option_value)+1)
            thisoption.value = value
        }
        thisoption.innerText = text;
        selector.appendChild(thisoption);
    }

    get_default_date_from_attribute(attribute_name){
        let date_value = this.element.getAttribute(attribute_name)
        let ret = moment(date_value, this.TIME_FORMAT)
        return ret.isValid() ? ret : moment.now()
    }

    get_data_from_attribute(attribute_name){
        let data = this.element.getAttribute(attribute_name)
        return data
    }

    setDateRange(from, till){
        this.from = from
        this.till = till
    }

    ShowDates(from, till) {
        let daynames = JSON.parse(this.get_data_from_attribute("calendar_locale_daynames"));
        let monthnames = JSON.parse(this.get_data_from_attribute("calendar_locale_monthnames"));
        this.RemoveAllDates();              
        var calendar = this.element.querySelectorAll(CSS_MATCHER_MINLOS_TABLE_ENTRY)[0];
        var calendar_inputrow = this.element.querySelectorAll(CSS_MATCHER_MINLOS_TABLE_ENTRY)[1];
            for (var m = moment(from); m.diff(till, 'days') <= 0; m.add(1, 'days')) {
                let dayname = daynames[m.weekday()]
                let monthname = monthnames[m.month()]
                let dayformatted = m.format(this.TIME_FORMAT)
                let thisday = document.createElement('th');
                if (m.isoWeekday() == 6 || m.isoWeekday() == 7){thisday.className = "weekend"};
                thisday.innerHTML = monthname +" "+ m.format('DD') + '<br>' + dayname + '<br> '  ;
                let thisdayinput = document.createElement('td');
                if (m.isoWeekday() == 6 || m.isoWeekday() == 7){thisdayinput.className = "weekend"};
                thisdayinput.innerHTML = '<input datevalue="'+dayformatted+'" name="" onkeypress="if ( isNaN( String.fromCharCode(event.keyCode) )) return false;"; onchange="if (this.value !== this.getAttribute(\'value\')) {this.style.color = \'red\'} else {this.style.color = \'black\'}" type="number" value="" min="1" maxlength="3" type="text" id="" class="min_los">'
                calendar.appendChild(thisday);
                calendar_inputrow.appendChild(thisdayinput);
                }
        // After creating the calendar, populate it with the values from API 
        this.renderAPIData();
    }

    RemoveAllDates() {
        let e = this.element.querySelectorAll(CSS_MATCHER_MINLOS_TABLE_ENTRY + ' td:not(:first-child)')
        e.forEach(function (e) {e.parentElement.removeChild(e)});
        e = this.element.querySelectorAll('table.tightTable th:not(:first-child)')
        e.forEach(function (e) {e.parentElement.removeChild(e)});
    }

    enableOrDisableSelector() {
        // selection value from the varminlos date range dropdown
        // 1 - custom value
        // 2 - 5 predefined intervals
        var selectionValue = document.getElementById('timespanselector').value;
        if (selectionValue == '1') {
            document.getElementById('custom_range_date_picker').disabled = false
            document.getElementById('custom_range_date_picker').style.borderBlockColor = "#8B2424";
        } else {
            document.getElementById('custom_range_date_picker').disabled = true
            document.getElementById('custom_range_date_picker').style.borderBlockColor = "#E2D2D2";

            if (selectionValue == '2') {this.from = moment().startOf('week'); this.till = moment(this.from).add(6,'days');};
            if (selectionValue == '3') {this.from = moment().startOf('day'); this.till = moment().add(29,'days').startOf('day'); };
            if (selectionValue == '4') {this.from = moment().startOf('day'); this.till = moment().add(89,'days').startOf('day'); };
            if (selectionValue == '5') {this.from = moment().startOf('year'); this.till = moment(this.from).add(364,'days'); };

            if (selectionValue != 1){
                this.ShowDates(this.from, this.till);
            }
        };

        document.getElementsByName("daterange")[0].value = this.from.format(this.get_data_from_attribute("calendar_date_format")) + ' - '  + this.till.format(this.get_data_from_attribute("calendar_date_format"));

    }

    bulkupdate(){
        let myvalue = document.getElementById('minlosvaluewholeperiod').value
        // Set myvalue for all dates in the period
        let valuefields = document.querySelectorAll('.tightTable > tbody:nth-child(2) > tr:nth-child(1) > td > input');
        valuefields.forEach(function (v) {v.value = myvalue; if (v.value !== v.getAttribute('value')) {v.style.color = 'red'} else {v.style.color = 'black'}});
    }

    showconfirmdialog_on_bulk_update(){
        this.confirmdialog.open({
            title: '',
            message: this.get_data_from_attribute("calendar_overwrite_data_warning"),
            onok: () => {
              this.bulkupdatebyweekday();
            },      
        });
    }

    bulkupdatebyweekday(){
            let myvalue = document.getElementById('minlosvaluebyweekday').value
            let selected = document.querySelectorAll(".mainblock input[type='checkbox']:checked")
            let selecteddays = []
            selected.forEach(function (s) {selecteddays.push(s.getAttribute('day'))})
            // Set myvalue for selected weekdays in the period
            let valuefields = document.querySelectorAll('.tightTable > tbody:nth-child(2) > tr:nth-child(1) > td > input');
            valuefields.forEach(function (v) {
                let thisday = moment(v.getAttribute('datevalue'), 'YYYY-MM-DD')
                if (selecteddays.includes(thisday.isoWeekday().toString())) {v.value = myvalue; if (v.value !== v.getAttribute('value')) {v.style.color = 'red'} else {v.style.color = 'black'}}
            });
    }

    async renderAPIData() {
        let l = document.getElementById('loader')
        l.style.visibility='visible'
        // clear all values
        this.deletealldatevalues();
        // fetch API data
        let fromFormat = this.from.format(this.TIME_FORMAT)
        let tillFormat = this.till.format(this.TIME_FORMAT)
        let request_url = this.buildQueryURL(fromFormat, tillFormat)

        if (request_url == ''){l.style.visibility='hidden'; return};

        let dates = await this.getDataFromAPI(request_url);

        // Return in case of no data
        if (typeof dates == "undefined") {l.style.visibility='hidden'; return}

        // Create a dictionary with all the date MinLOS values
        let datedict = {}
        dates.forEach(date => {
            datedict[date.date] = date;
        });
        
        // Iterate and Populate date value fields with the dictionary values
        let valuefields = document.querySelectorAll('.tightTable > tbody:nth-child(2) > tr:nth-child(1) > td > input');
        MinLosLevelColorDescription.disableMinLosColorLevelDescriptions()

        for (var i=0; i<valuefields.length; i++){
            // myvalue is an object containing the varminlos value and the source for tha value.
            let myvalue = datedict[valuefields[i].getAttribute('datevalue')]
            if (myvalue != undefined) {valuefields[i].value = myvalue.minlos; valuefields[i].setAttribute('value', myvalue.minlos);valuefields[i].setAttribute('level', myvalue.level)} // skip undefined values
            valuefields[i].style.color = 'black'

            // color the border of the editfeild based on the level
            // TODO: change the colors, take support from gary
            switch (myvalue.level) {
                case "GLOBAL_HOUSE":
                case "GLOBAL_SYSTEM":
                    valuefields[i].style.borderColor = enums.MinLosLevelColors.GLOBAL_HOUSE;
                    MinLosLevelColorDescription.enableGlobalHouseColorDescription();
                    break;
                case "HOUSE":
                    valuefields[i].style.borderColor = enums.MinLosLevelColors.HOUSE;
                    MinLosLevelColorDescription.enableHouseColorDescription()
                    break;
                case "ROOM_TYPE_PER_HOUSE":
                case "ROOM_TYPE":
                    valuefields[i].style.borderColor = enums.MinLosLevelColors.ROOM_TYPE;
                    MinLosLevelColorDescription.enableRoomTypeColorDescription()
                    break;
                case "ROOM":
                    valuefields[i].style.borderColor = enums.MinLosLevelColors.ROOM;
                    MinLosLevelColorDescription.enableRoomColorDescription()
                    break;
            }
        }
        l.style.visibility='hidden' // hide spinning wheel
    }

    buildQueryURL(datefrom, datetill) {

        const selectedOption = this.levels_selector.options[this.levels_selector.selectedIndex].id;
        const selectedLevel = this.levels_selector.options[this.levels_selector.selectedIndex].value;

        let myURL = `/api/v1/restrictions/varminlos/calculated?from=${datefrom}&to=${datetill}`

                // If room or room type not selected in the levels selector, show house level
                if (selectedOption == ''){
                    myURL = myURL + "&house_id=" + this.currentHouseID
                    return myURL
                }

                if (selectedOption != ''){

                    if (selectedLevel == enums.levelSelector.ROOM){
                        //Room level
                        myURL = myURL + "&room_id=" + selectedOption
                        return myURL
                    }else if (selectedLevel == enums.levelSelector.CATEGORY){
                        // Roomtype per house level
                        myURL = myURL + "&house_id=" + this.currentHouseID + "&custom_room_type_id=" + selectedOption
                        return myURL
                    }
                 
                }

    }

    selectorChanged() {
        if (this.unsavedChanges()) {this.showconfirmdialog()}
        else { this.HideAPIError(); this.renderAPIData(); this.currentlevel = this.levels_selector.selectedIndex}
   
    }

    deletealldatevalues() {
        // Clear all values from the input fields
        let valuefields = document.querySelectorAll('.tightTable > tbody:nth-child(2) > tr:nth-child(1) > td > input');
        valuefields.forEach(function (v) {v.value = ''; v.style.borderColor = 'white'});
    }

    // Connect to API and get VarMinLOS data for a period
    async getDataFromAPI(url) {
        
        try {
            const token = this.element.querySelector('meta[name="csrf-token"]').content;
            const res = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': token
                }
            });
            return await res.json();
        } catch (error) {
            // TODO handle error case
            alert(error);
        }
    }

    unsavedChanges() {
        // Verify there are unsaved updated values. This is done in order to show a unseved confirmation dialog before updating the calendar.
        const valuefields = document.querySelectorAll('.tightTable > tbody:nth-child(2) > tr:nth-child(1) > td > input');
        for (var i = 0; i<valuefields.length; i++){
            let thisdate_originalvalue = valuefields[i].getAttribute('value');
            let thisdate_currentvalue = valuefields[i].value;
            if (thisdate_originalvalue != thisdate_currentvalue) {return true};
        }
        return false
    }

    //Prepare JSON data from the VarMinLos calendar and POST it.
    async saveAPIData() {
        
        // SAVE ONLY MODIFIED VALUES (in red)
        this.HideAPIError();
        let valuefields = document.querySelectorAll('.tightTable > tbody:nth-child(2) > tr:nth-child(1) > td > input');
        let myarray = [] // array of Varminlos objects (single dates and or date intervals)
        let period_start = ""
        let thisperiod = ""
        const selectedHouseId = this.currentHouseID // document.querySelectorAll('div.menuitem.selected')[0].id.replace('menuitem_','');
       
        const selectedLevelId = this.levels_selector.options[this.levels_selector.selectedIndex].id;
        const selectedLevel = this.levels_selector.options[this.levels_selector.selectedIndex].value;

        var selectedroomtypeid = ''
        var selectedroomid = ''

        if(selectedLevel == enums.levelSelector.ROOM){
            selectedroomid = selectedLevelId;
        }
        if(selectedLevel == enums.levelSelector.CATEGORY){
            selectedroomtypeid = selectedLevelId;
        }

        // Iterate over the calendar values
        for (var i = 0; i<valuefields.length; i++){
            let thisdate = valuefields[i].getAttribute('datevalue');
            let thisdate_originalvalue = valuefields[i].getAttribute('value');
            let thisdate_currentvalue = valuefields[i].value;

            if (thisdate_currentvalue<=0 || thisdate_currentvalue=="")  {this.DisplayAPIError(this.get_data_from_attribute("api_invalid_input_data_err")); return}
            
            if (thisdate_originalvalue != thisdate_currentvalue) {
                
                // Is this the start, extension or end of an interval? 
                // (compare to the next and previous value, considering that the next value always has to be a user entered value, and checking the boundaries)
                // 
                if ((i<valuefields.length-1 && valuefields[i].value == valuefields[i+1].value && valuefields[i+1].value != valuefields[i+1].getAttribute('value')) || (i>0 && valuefields[i].value == valuefields[i-1].value && valuefields[i-1].value != valuefields[i-1].getAttribute('value'))) {                     
                    // If this is a new interval. Append previous interval if exists.
                    if (thisperiod != "" && thisperiod.minlos != thisdate_currentvalue){myarray.push (thisperiod); thisperiod = ""; period_start = "";}
                    
                    // Create/extend the interval
                    if (period_start == '') {period_start = thisdate}
                    thisperiod = this.CreateVarMinLosObject(thisdate_currentvalue, 'Interval', period_start, thisdate, selectedroomid, selectedHouseId, selectedroomtypeid);

                    // Reached the end of calendar or an empty calendar value. Should add the current interval to the array
                    let nextvalue
                    try {nextvalue = valuefields[i+1].value}catch{nextvalue = ''}// There is no next value. This is the end of the period
                    if((i == valuefields.length-1 || nextvalue == "" ) && thisperiod != "") {myarray.push (thisperiod)}

                } else {

                    // End of existing interval
                    if(thisperiod != ""){myarray.push (thisperiod)};
                    thisperiod = ""
                    period_start = ""

                    // Single date value
                    myarray.push (this.CreateVarMinLosObject(thisdate_currentvalue, 'ExactDate', thisdate, thisdate, selectedroomid, selectedHouseId, selectedroomtypeid));
                }
                
            } else {

                 // End of existing interval. (Next value wasn't modified)
                 if(thisperiod != ""){myarray.push (thisperiod)};
                 thisperiod = ""
                 period_start = ""
            }
          
        }

       
        // Only send data if there IS data
        if(myarray.length > 0 ){
            let MyJSON = JSON.stringify(myarray)
            let reply = await this.PostAPIData('/api/v1/restrictions/varminlos/add_all', MyJSON);
            if (reply.status != 200) {this.DisplayAPIError("Error: \n"+ reply.message);}
            // Refresh data (default values, etc) after saving
            this.renderAPIData();
        } 
    }

    CreateVarMinLosObject(minlosvalue, objectttype, datefrom, datetill, roomid, houseid, roomtypeid){
        /// This method creates each object for the array of VarMinLos objects, according to the passed arguemtns

        let thisAPIobject = {}
        // MinLos value for this date/interval
        thisAPIobject.minlos = minlosvalue
        // Exact date or interval
        thisAPIobject.type = objectttype
        
        // Exact date vs interval
        if (thisAPIobject.type == 'ExactDate'){
            thisAPIobject.exact_day = datefrom
        } else {
            thisAPIobject.from = datefrom;
            thisAPIobject.to = datetill;
        }

        //Room level
        if (roomid != ''){
            thisAPIobject.room_id = roomid
            return thisAPIobject
        }
        // House level
        if (houseid != '' && roomtypeid == ''){
            thisAPIobject.house_id = houseid.toUpperCase().replaceAll('_', '-')
            return thisAPIobject
        }
        // Roomtype per house level
        if (roomtypeid != ''){
            thisAPIobject.custom_room_type_id = roomtypeid
            thisAPIobject.house_id = houseid.toUpperCase().replaceAll('_', '-')
            return thisAPIobject
        }
    }

    async PostAPIData(url, postdata) {

        try {
            
            const token = this.element.querySelector('meta[name="csrf-token"]').content;
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': token
                },
                body: postdata
            });
            return await res.json();
        } catch (error) {
            // TODO handle error case
            this.DisplayAPIError("Error:\n"+error);
        }

    }

    DisplayAPIError (errormsg) {this.apierrormsg.innerText = errormsg; this.apierrormsg.style.display= 'block';}
    HideAPIError () {this.apierrormsg.innerText = '';this.apierrormsg.style.display= 'none';}



    showconfirmdialog() {

        let previouslevel = this.currentlevel

        this.confirmdialog.open({
          title: 'Unsaved changes',
          message: this.get_data_from_attribute("api_unsaved_data_warning"),
          onok: () => {
            this.HideAPIError(); this.renderAPIData();
          },
          oncancel: () => {this.levels_selector.selectedIndex = previouslevel}
    
      });
        }

    async deleteuserdata() {

        let warnmsg

        if (this.unsavedChanges()) {
            // warn about unsaved data
            warnmsg = this.get_data_from_attribute("api_unsaved_data_warning");
        } else{
            // warn about deletion
            warnmsg = this.get_data_from_attribute("api_data_deletion_warning");
        };

        this.confirmdialog.open({
            title: this.get_data_from_attribute("api_data_deletion_warning_header"),
            message: warnmsg,
            onok: () => {this.processApiDataDeletion();},
            oncancel: () => {return}
      
        });
      
    }

    async processApiDataDeletion() {
        let thisAPIobject = {}
        
        thisAPIobject.from = this.from.format(this.TIME_FORMAT)
        thisAPIobject.to = this.till.format(this.TIME_FORMAT)
        //thisAPIobject.room_id = this.currentlevel

        const selectedOption = this.levels_selector.options[this.levels_selector.selectedIndex].id;
        const selectedLevel = this.levels_selector.options[this.levels_selector.selectedIndex].value;
        let myURL = "/api/v1/restrictions/varminlos/delete";

        // If room or room type not selected in the levels selector, show house level
        if (selectedOption == ''){
            thisAPIobject.house_id = this.currentHouseID // house level
        }

        if (selectedOption != ''){

            if (selectedLevel == enums.levelSelector.ROOM){
                //Room level
                thisAPIobject.room_id = selectedOption
                
            }else if (selectedLevel == enums.levelSelector.CATEGORY){
                // Roomtype per house level
                thisAPIobject.house_id = this.currentHouseID // house level
                thisAPIobject.custom_room_type_id = selectedOption
           
            }
         
        }
        let MyJSON = JSON.stringify(thisAPIobject);
        let reply = await this.PostAPIData(myURL, MyJSON);
        if (reply.status != 200) {this.DisplayAPIError("Error: \n"+ reply.message);}
        // Refresh data (default values, etc) after deleting
        this.renderAPIData();
    }
    


}


